import { InvalidEmailCell } from "@ext/enterprise/components/admin/settings/components/InvalidEmailCell";
import type { GesCloudMemberAiAgentAccess } from "@ext/enterprise-cloud/GesCloudApi";
import { GesCommonUserBadge } from "@ext/enterpriseCommon/components/roleBadges/GesCommonUserBadge";
import { onwerBadgeIcon, userBadgesColumnId } from "@ext/enterpriseCommon/components/roleBadges/UserBadgesConfig";
import { UserBadgesWrapper } from "@ext/enterpriseCommon/components/roleBadges/UserBadgesWrapper";
import t from "@ext/localization/locale/translate";
import type { ColumnDef } from "@ui-kit/DataTable";
import { TextOverflowTooltip } from "@ui-kit/Tooltip";
import { AiAgentAccessSwitch } from "./AiAgentAccessSwitch";

export const AI_AGENT_ACCESS_EMAIL_COLUMN_ID = "email";

export const getAiAgentAccessTableColumns = (
	onAiAgentAccessChange: (email: string, aiAgentAccess: boolean) => Promise<void>,
): ColumnDef<GesCloudMemberAiAgentAccess>[] => [
	{
		id: AI_AGENT_ACCESS_EMAIL_COLUMN_ID,
		accessorKey: "email",
		header: t("enterprise-cloud.org-settings.users.email"),
		cell: ({ row }) => <InvalidEmailCell value={row.original.email} />,
	},
	{
		accessorKey: "name",
		header: t("enterprise-cloud.org-settings.users.name"),
		cell: ({ row }) => <TextOverflowTooltip>{row.original.name}</TextOverflowTooltip>,
	},
	{
		id: userBadgesColumnId,
		cell: ({ row }) => {
			const { isOwner, isAdmin } = row.original;
			if (!isOwner && !isAdmin) return null;

			return (
				<UserBadgesWrapper>
					<GesCommonUserBadge
						icon={isOwner ? onwerBadgeIcon : ""}
						label={
							isOwner
								? t("enterprise-cloud.org-settings.users.roles.owner")
								: t("enterprise-cloud.org-settings.users.roles.admin")
						}
					/>
				</UserBadgesWrapper>
			);
		},
	},
	{
		id: "aiAgentAccess",
		header: t("enterprise-cloud.org-settings.ai-wallet.access.column"),
		size: 160,
		cell: ({ row }) => <AiAgentAccessSwitch member={row.original} onChange={onAiAgentAccessChange} />,
		enableSorting: false,
	},
];
